/**
 * Pick Your Mix. Tap flavors or run Surprise Me, then review the mix
 * in <daddl-overlay> and add those lines to cart. Overlay is portaled
 * to document.body so section overflow cannot trap it.
 */
if (!customElements.get('daddl-pick-mix')) {
  customElements.define(
    'daddl-pick-mix',
    class DaddlPickMix extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-pick-mix-item]:not([data-sold-out])'));
        this.allItems = Array.from(this.querySelectorAll('[data-pick-mix-item]'));
        this.addBtn = this.querySelector('[data-pick-mix-add]');
        this.randomizeBtn = this.querySelector('[data-pick-mix-randomize]');
        this.countEl = this.querySelector('[data-pick-mix-count]');
        this.floatBar = this.querySelector('[data-pick-mix-float]');
        this.floatCountEl = this.querySelector('[data-pick-mix-float-count]');
        this.floatAddBtn = this.querySelector('[data-pick-mix-float-add]');
        this.floatRandomizeBtn = this.querySelector('[data-pick-mix-float-randomize]');
        this.overlay = this.querySelector('daddl-overlay');
        this.resultList = this.querySelector('[data-pick-mix-result-list]');
        this.resultTotal = this.querySelector('[data-pick-mix-result-total]');
        this.resultAdd = this.querySelector('[data-pick-mix-result-add]');
        this.resultMix = this.querySelector('[data-pick-mix-result-mix]');
        this.resultKeep = this.querySelector('[data-pick-mix-result-keep]');
        this.products = this.readProducts();

        this.cartAddUrl = this.getAttribute('data-cart-add');
        this.moneyFormat = this.getAttribute('data-money-format') || '{{amount}}';
        this.emptyText = this.getAttribute('data-str-empty') || '';
        this.addLabel = this.getAttribute('data-str-add') || '';
        this.addTheseLabel = this.getAttribute('data-str-add-these') || this.addLabel;
        this.randomizeLabel = this.getAttribute('data-str-surprise') || '';
        this.flavorOne = this.getAttribute('data-str-flavor-one') || '';
        this.flavorOther = this.getAttribute('data-str-flavor-other') || '';
        this.addingLabel = this.getAttribute('data-str-adding') || '';
        this.addedLabel = this.getAttribute('data-str-added') || '';
        this.errorLabel = this.getAttribute('data-str-error') || '';
        this.randomizingLabel = this.getAttribute('data-str-randomizing') || '';
        this.totalLabel = this.getAttribute('data-str-total') || '';
        this.isRandomizing = false;

        this.onItemClick = this.onItemClick.bind(this);
        this.onItemKey = this.onItemKey.bind(this);
        this.openResult = this.openResult.bind(this);
        this.addSelection = this.addSelection.bind(this);
        this.runRandomize = this.runRandomize.bind(this);

        this.items.forEach((item) => {
          item.addEventListener('click', this.onItemClick);
          item.addEventListener('keydown', this.onItemKey);
        });
        this.addBtn?.addEventListener('click', this.openResult);
        this.floatAddBtn?.addEventListener('click', this.openResult);
        this.randomizeBtn?.addEventListener('click', this.runRandomize);
        this.floatRandomizeBtn?.addEventListener('click', () => this.proxyRandomize());
        this.resultAdd?.addEventListener('click', this.addSelection);
        this.resultMix?.addEventListener('click', () => {
          this.overlay?.close();
          this.runRandomize();
        });
        this.resultKeep?.addEventListener('click', () => this.overlay?.close());

        if (this.overlay && this.overlay.parentElement !== document.body) {
          document.body.append(this.overlay);
        }

        this.preloadImages();
        this.updateUI();
        this.watchFloat();
      }

      disconnectedCallback() {
        this.overlay?.remove();
      }

      readProducts() {
        const node = this.querySelector('[data-pick-mix-products]');
        if (!node) return [];
        try {
          return JSON.parse(node.textContent);
        } catch (err) {
          return [];
        }
      }

      selected() {
        return this.allItems.filter((el) => el.classList.contains('is-selected') && !el.hasAttribute('data-sold-out'));
      }

      countLabel(count) {
        if (count === 0) return this.emptyText;
        if (count === 1) return this.flavorOne;
        return this.flavorOther.replace('__COUNT__', String(count));
      }

      updateUI() {
        const count = this.selected().length;
        const label = this.countLabel(count);
        const empty = count === 0;
        if (this.countEl) this.countEl.textContent = label;
        if (this.floatCountEl) this.floatCountEl.textContent = label;
        if (this.addBtn) {
          this.addBtn.disabled = empty;
          this.addBtn.classList.toggle('is-visible', !empty);
        }
        if (this.floatAddBtn) this.floatAddBtn.disabled = empty;
        this.allItems.forEach((el) => {
          el.setAttribute('aria-pressed', el.classList.contains('is-selected') ? 'true' : 'false');
        });
      }

      onItemClick(event) {
        if (this.isRandomizing) return;
        event.currentTarget.classList.toggle('is-selected');
        event.currentTarget.setAttribute(
          'aria-pressed',
          event.currentTarget.classList.contains('is-selected') ? 'true' : 'false'
        );
        this.updateUI();
      }

      onItemKey(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.onItemClick(event);
      }

      openResult() {
        if (this.isRandomizing) return;
        const picks = this.selected();
        if (!picks.length || !this.overlay || !this.resultList) return;

        this.resultList.replaceChildren();
        let total = 0;

        picks.forEach((el) => {
          const row = document.createElement('li');
          row.className = 'daddl-pick-mix__result-item';

          const img = document.createElement('img');
          img.className = 'daddl-pick-mix__result-img';
          img.src = el.getAttribute('data-image') || '';
          img.alt = el.getAttribute('data-title') || '';
          img.width = 72;
          img.height = 72;

          const body = document.createElement('div');
          body.className = 'daddl-pick-mix__result-copy';
          const name = document.createElement('p');
          name.className = 'daddl-pick-mix__result-name';
          name.textContent = el.getAttribute('data-title') || '';
          const price = document.createElement('p');
          price.className = 'daddl-pick-mix__result-price';
          price.textContent = el.getAttribute('data-price-formatted') || '';
          body.append(name, price);

          row.append(img, body);
          this.resultList.append(row);
          total += Number(el.getAttribute('data-price')) || 0;
        });

        if (this.resultTotal) {
          this.resultTotal.textContent = this.totalLabel.replace('__AMOUNT__', this.formatMoney(total));
        }
        if (this.resultAdd) {
          this.resultAdd.disabled = false;
          this.resultAdd.textContent = this.addTheseLabel;
        }
        this.overlay.open();
      }

      formatMoney(cents) {
        const value = (Math.max(0, cents) / 100).toFixed(2);
        const whole = value.split('.')[0];
        return this.moneyFormat
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
          .replace(/\{\{\s*amount\s*\}\}/g, value);
      }

      async addSelection() {
        const picks = this.selected();
        if (!picks.length || !this.cartAddUrl) return;

        this.setAddState(this.addingLabel, this.addingLabel, true);

        const itemsMap = new Map();
        picks.forEach((el) => {
          const id = Number(el.getAttribute('data-variant-id'));
          if (!id) return;
          itemsMap.set(id, (itemsMap.get(id) || 0) + 1);
        });

        // No line-item properties: Shopify keys cart lines by variant +
        // properties, so tagging these would put picked bags on their own row
        // beside the identical bag added from the PDP. Attribution is a cart
        // attribute instead (window.daddlTagCartSource in daddl-cart.js).
        const items = [];
        itemsMap.forEach((quantity, id) => {
          items.push({ id, quantity });
        });

        try {
          const cartElem = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections =
            cartElem && typeof cartElem.getSectionsToRender === 'function'
              ? cartElem.getSectionsToRender().map((section) => section.id)
              : [];
          const body = { items };
          if (sections.length) {
            body.sections = sections;
            body.sections_url = window.location.pathname;
          }

          const res = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
          });
          if (!res.ok) throw new Error('cart');
          const parsed = await res.json();

          this.setAddState(this.addedLabel, this.addedLabel, true);
          if (typeof window.daddlTagCartSource === 'function') {
            window.daddlTagCartSource('daddl_pick_and_mix');
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'daddl-pick-mix', cartData: parsed });
          }
          if (cartElem && typeof cartElem.renderContents === 'function') {
            if (typeof cartElem.setActiveElement === 'function') {
              cartElem.setActiveElement(document.activeElement);
            }
            cartElem.renderContents(parsed);
          }
          if (cartElem && cartElem.classList.contains('is-empty')) {
            cartElem.classList.remove('is-empty');
          }

          window.setTimeout(() => {
            this.overlay?.close();
            this.allItems.forEach((el) => el.classList.remove('is-selected'));
            this.updateUI();
            this.setAddState(this.addLabel, this.addTheseLabel, false);
          }, 700);
        } catch (err) {
          this.setAddState(this.errorLabel, this.errorLabel, false);
          window.setTimeout(() => this.setAddState(this.addLabel, this.addTheseLabel, false), 2200);
        }
      }

      setAddState(footerLabel, resultLabel, disabled) {
        if (this.addBtn) {
          this.addBtn.textContent = footerLabel;
          this.addBtn.disabled = disabled;
        }
        if (this.floatAddBtn) {
          this.floatAddBtn.textContent = footerLabel;
          this.floatAddBtn.disabled = disabled;
        }
        if (this.resultAdd) {
          this.resultAdd.textContent = resultLabel;
          this.resultAdd.disabled = disabled;
        }
      }

      preloadImages() {
        this.products.forEach((product) => {
          if (!product.img) return;
          const img = new Image();
          img.src = product.img;
        });
      }

      proxyRandomize() {
        const footer = this.querySelector('.daddl-pick-mix__footer');
        if (!footer) {
          this.runRandomize();
          return;
        }
        const rect = footer.getBoundingClientRect();
        const atBottom = rect.bottom <= window.innerHeight && rect.bottom >= window.innerHeight * 0.7;
        if (atBottom) {
          this.runRandomize();
          return;
        }
        window.scrollTo({
          top: Math.max(0, window.pageYOffset + rect.bottom - window.innerHeight + 8),
          behavior: 'smooth',
        });
        window.setTimeout(() => this.runRandomize(), 750);
      }

      runRandomize() {
        if (this.isRandomizing || !this.items.length) return;
        this.isRandomizing = true;
        this.overlay?.close();
        this.randomizeBtn?.classList.add('is-animating');
        if (this.randomizeBtn) this.randomizeBtn.disabled = true;
        const textEl = this.randomizeBtn?.querySelector('[data-pick-mix-randomize-text]');
        if (textEl) textEl.textContent = this.randomizingLabel;

        this.allItems.forEach((el) => {
          el.classList.remove('is-selected', 'is-settling', 'is-randomizing');
        });

        const pool = this.items.slice().sort(() => Math.random() - 0.5);
        const pickCount = Math.min(Math.floor(Math.random() * 4) + 3, pool.length);
        const picks = pool.slice(0, pickCount);
        const originals = this.allItems.map((el) => {
          const imgEl = el.querySelector('.daddl-pick-mix__image');
          const nameEl = el.querySelector('.daddl-pick-mix__item-name');
          const priceEl = el.querySelector('.daddl-pick-mix__item-price');
          const bgEl = el.querySelector('.daddl-pick-mix__item-bg');
          return {
            el,
            imgEl,
            nameEl,
            priceEl,
            bgEl,
            imgSrc: imgEl ? imgEl.src : '',
            imgSrcset: imgEl ? imgEl.getAttribute('srcset') || '' : '',
            imgSizes: imgEl ? imgEl.getAttribute('sizes') || '' : '',
            nameText: nameEl ? nameEl.textContent : '',
            priceText: priceEl ? priceEl.textContent : '',
            bgImg: bgEl ? bgEl.style.backgroundImage : '',
          };
        });

        const stopTimes = originals.map((_, i) => 1500 + i * 160 + Math.random() * 100);
        stopTimes.sort(() => Math.random() - 0.5);
        const startTime = Date.now();
        let settled = 0;

        const slotSpeed = (elapsed) => {
          if (elapsed < 400) return 70;
          const t = (elapsed - 400) / 900;
          return Math.min(70 + 340 * t * t, 420);
        };

        originals.forEach((data, i) => {
          data.el.classList.add('is-randomizing');
          const tick = () => {
            const elapsed = Date.now() - startTime;
            if (elapsed >= stopTimes[i]) {
              if (data.imgEl) {
                data.imgEl.removeAttribute('srcset');
                data.imgEl.removeAttribute('sizes');
                data.imgEl.src = data.imgSrc;
                if (data.imgSrcset) data.imgEl.setAttribute('srcset', data.imgSrcset);
                if (data.imgSizes) data.imgEl.setAttribute('sizes', data.imgSizes);
              }
              if (data.nameEl) data.nameEl.textContent = data.nameText;
              if (data.priceEl) data.priceEl.textContent = data.priceText;
              if (data.bgEl) data.bgEl.style.backgroundImage = data.bgImg;
              data.el.classList.remove('is-randomizing');
              data.el.classList.add('is-settling');
              if (picks.includes(data.el)) data.el.classList.add('is-selected');
              settled += 1;
              if (settled === originals.length) {
                window.setTimeout(() => {
                  this.allItems.forEach((el) => el.classList.remove('is-settling'));
                  this.updateUI();
                  this.isRandomizing = false;
                  if (this.randomizeBtn) this.randomizeBtn.disabled = false;
                  this.randomizeBtn?.classList.remove('is-animating');
                  if (textEl) textEl.textContent = this.randomizeLabel;
                  this.burstConfetti();
                  this.openResult();
                }, 400);
              }
              return;
            }

            if (this.products.length) {
              const product = this.products[Math.floor(Math.random() * this.products.length)];
              if (data.imgEl && product.img) {
                data.imgEl.removeAttribute('srcset');
                data.imgEl.removeAttribute('sizes');
                data.imgEl.src = product.img;
              }
              if (data.nameEl) data.nameEl.textContent = product.title;
              if (data.priceEl) data.priceEl.textContent = product.price;
              if (data.bgEl && product.img) data.bgEl.style.backgroundImage = 'url(' + product.img + ')';
            }
            window.setTimeout(tick, slotSpeed(elapsed));
          };
          tick();
        });
      }

      watchFloat() {
        if (!this.floatBar || !('IntersectionObserver' in window)) return;
        const firstCard = this.querySelector('.daddl-pick-mix__item');
        const footer = this.querySelector('.daddl-pick-mix__footer');
        let sectionIn = false;
        let footerIn = false;
        const sync = () => {
          this.floatBar.classList.toggle('is-visible', sectionIn && !footerIn);
        };
        new IntersectionObserver((entries) => {
          sectionIn = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.5 }).observe(firstCard || this);
        if (footer) {
          new IntersectionObserver((entries) => {
            footerIn = entries[0].isIntersecting;
            sync();
          }, { threshold: 0.1 }).observe(footer);
        }
      }

      burstConfetti() {
        if (typeof confetti !== 'function') {
          if (this.confettiLoading) return;
          this.confettiLoading = true;
          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
          script.onload = () => this.burstConfetti();
          document.head.append(script);
          return;
        }
        const hex = ['#810057', '#E8F685', '#F9EDE1', '#A64B85'];
        const end = Date.now() + 700;
        const frame = () => {
          confetti({
            particleCount: 2,
            angle: 60,
            spread: 55,
            origin: { x: 0.15, y: 0.7 },
            colors: hex,
            zIndex: 100000,
          });
          confetti({
            particleCount: 2,
            angle: 120,
            spread: 55,
            origin: { x: 0.85, y: 0.7 },
            colors: hex,
            zIndex: 100000,
          });
          if (Date.now() < end) requestAnimationFrame(frame);
        };
        frame();
      }
    }
  );
}
